import { FieldModel, ValidateErrorContext } from 'forms/shared/types';
import { BaseCustomValidator } from '../types';

const hasValueBaseValidator: BaseCustomValidator<FieldModel> = (validateModel, validate) => (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  let errors: ValidateErrorContext<any>[] = [];
  let instanceErrors = validateModel(
    { value: value?.value ?? undefined },
    { value: { presence: true } },
    { ...globalOptions, ...options }
  );
  if (typeof instanceErrors !== 'boolean') {
    errors = [...errors, ...instanceErrors];
  }

  if (options?.validator) {
    instanceErrors = validateModel(
      { value: value?.value ?? undefined },
      { value: options.validator },
      { ...globalOptions, ...options }
    );
    if (typeof instanceErrors !== 'boolean') {
      errors = [...errors, ...instanceErrors];
    }
  }

  // This is a bit of a hack. We change attribute from 'value' to 'hasValue' and
  // use the removeValidatorFromAttribute to remove it. This will make user
  // controls be assigned to just the field name, such as 'Explanation' and
  // still be mapped correctly, versus being mapped to 'Explanation.value'. If
  // we use 'Explanation.value', all rules have to be within hasValue or
  // otherwise, you'll get mapping errors at 'Explanation' and the field won't
  // have red borders.
  errors = errors.map((e) => ({ ...e, attribute: 'hasValue' }));

  if (errors.length > 0) { return errors; }

  return null;
};

export default hasValueBaseValidator;
